export const colorOne ='rgba(121, 255, 122, 1)';
export const colorTwo ='rgba(72, 69, 255, 1)';
export const colorThree ='rgba(135, 0, 226, 1)';
export const colorFour ='rgba(255, 156, 0, 1)';
export const colorFive ='rgba(255, 0, 0, 1)';   
export const colorSix ='rgba(100, 0, 0, 1)';
export const colorSeven ='rgba(124, 179, 66, 1)';
export const colorEight ='rgba(0, 229, 255, 1)';
export const colorNine ='rgba(236, 64, 122, 1)';
export const colorTen='rgba(0, 137, 123, 1)';

 

